module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3",
    on: {
      "click": _vm.increment
    }
  }, [_c('button', {
    staticClass: "btn-recharge",
    attrs: {
      "id": "btnRecharge1",
      "type": "button",
      "name": "button"
    }
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "value-recharge",
    attrs: {
      "id": "valueRecharge1"
    }
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.value)))])]), _vm._v(" "), _c('i', {
    staticClass: "icon-plus pull-left icon-center-recharge"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-78623cc9!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/recharge/btn-recharge-value.vue
// module id = 2173
// module chunks = 1